import { getData } from './http';
import { isDefined } from './isDefined';
import Optional from './optional';
import urlCreator from './urlCreator';

const DATA_COUNT = 1000;

export default async function getFullTableData(url, queryParams) {
  let elements = [];
  try {
    const { data, meta } = await getData(
      urlCreator(url, {
        ...queryParams,
        page: { size: DATA_COUNT },
        stats: { total: 'count' }
      })
    );
    elements = data;
    const count = meta?.stats?.total?.count;

    if (isDefined(count) && count > DATA_COUNT) {
      const pages = Math.floor(count / DATA_COUNT);
      for (let i = 1; i <= pages; i++) {
        const response = await getData(
          urlCreator(url, {
            ...queryParams,
            page: { size: DATA_COUNT, number: i + 1 }
          })
        );
        elements = [...elements, ...response.data];
      }
    }
  } catch {
  } finally {
    return elements;
  }
}

export const altGetFullTableData = async (
  url,
  queryParams,
  size,
  fromMitel
) => {
  let elements = [];
  try {
    const response = await getData({
      options: {
        url: urlCreator(url, {
          ...queryParams,
          size: Optional(size).or(DATA_COUNT)
        })
      }
    });

    elements = response.data;
    const count = Number(Optional(response?.headers?.['x-total-count']).or(0));

    if (isDefined(count) && count > Optional(size).or(DATA_COUNT)) {
      const pages = Math.floor(count / Optional(size).or(DATA_COUNT));

      for (let i = 1; i <= pages; i++) {
        const response = await getData({
          options: {
            url: urlCreator(url, {
              ...queryParams,
              size: Optional(size).or(DATA_COUNT),
              page: fromMitel ? i + 1 : { number: i + 1 }
            })
          }
        });

        elements = [...elements, ...response.data];
      }
    }
  } catch {
  } finally {
    return elements;
  }
};
